
import { useShowCasePageContent } from "utils";
import {
  Page,
  ContentContainer,
  Loading,
  Error
} from "components/atoms";
import _ from "lodash";
import { useEffect, useState } from "react";
import { ShowCaseHeader } from "./header";
import { ShowCaseContent } from "./content";
import { ScrollToTopButton } from "components/molecules";
import { ErrorBoundary } from 'react-error-boundary'

const ShowCasePage = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  const {
    OgTitle,
    HeroSectionTitle,
    HeroSectionSuperscript,
    HeroSectionBlockOverlayColor,
    FeaturedSubpages,
    InitialSubpages,
    FiltersCollection,
    ShowLayoutToggle,
    Slides,
    ShowPublicationDateReadTimeContentType
  } = useShowCasePageContent();

  const _Slides = Slides.filter((v) => Boolean(v?.ActiveTag) && Boolean(v?.FeaturedSubPage)).map(v => v);
  const _FeaturedSubpages = _Slides.concat(FeaturedSubpages).slice(0, 3);

  const headerProps = {
    loading,
    HeroSectionTitle,
    OgTitle,
    HeroSectionSuperscript,
    HeroSectionBlockOverlayColor,
    FeaturedSubpages: _FeaturedSubpages
  }

  const contentProps = {
    InitialSubpages,
    FiltersCollection,
    ShowLayoutToggle,
    ShowPublicationDateReadTimeContentType
  }

  if (loading) return <Loading />;

  return (
    <>
        <ShowCaseHeader {...headerProps} />

      <ContentContainer>
        <div className="articleContent" id="showCasePage">
          <Page
            flexDirection={"column"}
            className="mobile-column noPadding">

            {/* Fixed Element Scroll To Top Button */}
            <ScrollToTopButton />
            {/* Fixed Element Scroll To Top Button */}

            {/*Content*/}
              <ShowCaseContent {...contentProps} />
          </Page >
        </div>
      </ContentContainer >
    </>
  );
};

export default ShowCasePage;
